namespace RioERP.Orders {
    export interface OrdersForm {
        OrderDate: Serenity.DateEditor;
        OrderNumber: Serenity.StringEditor;
        ESourceType: Serenity.EnumEditor;
        EPaymentMode: Serenity.EnumEditor;
        CashAmount: Serenity.DecimalEditor;
        OnlineAmount: Serenity.DecimalEditor;
        Mode: Serenity.LookupEditor;
        Level: Serenity.LookupEditor;
        SourceName: Serenity.StringEditor;
        ReferredBy: Serenity.LookupEditor;
        SourceOrderNumber: Serenity.StringEditor;
        FranchiseeId: Serenity.LookupEditor;
        VendorId: Serenity.LookupEditor;
        CustomerId: Serenity.LookupEditor;
        CustomerName1: Serenity.StringEditor;
        InvoiceCompanyId: Serenity.LookupEditor;
        CustomerEmail1: Serenity.EmailEditor;
        CustomerEmail2: Serenity.EmailEditor;
        CustomerMobile11: Serenity.StringEditor;
        CustomerMobile21: Serenity.StringEditor;
        EInvoiceTo: Serenity.EnumEditor;
        EInvoiceStatus: Serenity.EnumEditor;
        EOrderStatus: Serenity.EnumEditor;
        ShippingProviderId: Serenity.LookupEditor;
        ShippingAddress1: Serenity.StringEditor;
        ShippingAddress2: Serenity.StringEditor;
        ShippingCity: Serenity.StringEditor;
        ShippingStateId: Serenity.LookupEditor;
        ShippingCountry: Serenity.StringEditor;
        ShippingPincode: Serenity.IntegerEditor;
        EShippingType: Serenity.EnumEditor;
        EOrderProcessBy: Serenity.EnumEditor;
        EShippingStatus: Serenity.EnumEditor;
        ShippingToName: Serenity.StringEditor;
        ExpectedShippingDate: Serenity.DateEditor;
        ShippingNote: Serenity.TextAreaEditor;
        BillingAddress1: Serenity.StringEditor;
        BillingAddress2: Serenity.StringEditor;
        BillingCity: Serenity.StringEditor;
        BillingStateId: Serenity.LookupEditor;
        BillingCountry: Serenity.StringEditor;
        BillingPincode: Serenity.IntegerEditor;
        OrderProducts: OrderProductsEditor;
        GrossAmount: Serenity.DecimalEditor;
        DiscountAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        NetAmountAfterFrDiscount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        DiscountCoupon: Serenity.StringEditor;
        EFranchiseeDiscountType: Serenity.EnumEditor;
        EFranchiseeDiscount: Serenity.EnumEditor;
        FranchiseeDiscountValue: Serenity.DecimalEditor;
        FranchiseeDiscountAmount: Serenity.DecimalEditor;
        EPaymentStatus: Serenity.EnumEditor;
        EPaymentType: Serenity.EnumEditor;
        Gstin: Serenity.StringEditor;
        Note: Serenity.TextAreaEditor;
        EmailSendCount: Serenity.IntegerEditor;
        OrderInstallments: OrderInstallmentEditor;
        HasBooks: Serenity.BooleanEditor;
        MailId: Serenity.StringEditor;
        CurrencyId: Serenity.LookupEditor;
        IsEmailSent: Serenity.BooleanEditor;
        LastEmailSentDate: Serenity.DateEditor;
        FreezeData: Serenity.BooleanEditor;
    }

    export class OrdersForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.Orders';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrdersForm.init)  {
                OrdersForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.LookupEditor;
                var w5 = s.EmailEditor;
                var w6 = s.IntegerEditor;
                var w7 = s.TextAreaEditor;
                var w8 = OrderProductsEditor;
                var w9 = OrderInstallmentEditor;
                var w10 = s.BooleanEditor;

                Q.initFormType(OrdersForm, [
                    'OrderDate', w0,
                    'OrderNumber', w1,
                    'ESourceType', w2,
                    'EPaymentMode', w2,
                    'CashAmount', w3,
                    'OnlineAmount', w3,
                    'Mode', w4,
                    'Level', w4,
                    'SourceName', w1,
                    'ReferredBy', w4,
                    'SourceOrderNumber', w1,
                    'FranchiseeId', w4,
                    'VendorId', w4,
                    'CustomerId', w4,
                    'CustomerName1', w1,
                    'InvoiceCompanyId', w4,
                    'CustomerEmail1', w5,
                    'CustomerEmail2', w5,
                    'CustomerMobile11', w1,
                    'CustomerMobile21', w1,
                    'EInvoiceTo', w2,
                    'EInvoiceStatus', w2,
                    'EOrderStatus', w2,
                    'ShippingProviderId', w4,
                    'ShippingAddress1', w1,
                    'ShippingAddress2', w1,
                    'ShippingCity', w1,
                    'ShippingStateId', w4,
                    'ShippingCountry', w1,
                    'ShippingPincode', w6,
                    'EShippingType', w2,
                    'EOrderProcessBy', w2,
                    'EShippingStatus', w2,
                    'ShippingToName', w1,
                    'ExpectedShippingDate', w0,
                    'ShippingNote', w7,
                    'BillingAddress1', w1,
                    'BillingAddress2', w1,
                    'BillingCity', w1,
                    'BillingStateId', w4,
                    'BillingCountry', w1,
                    'BillingPincode', w6,
                    'OrderProducts', w8,
                    'GrossAmount', w3,
                    'DiscountAmount', w3,
                    'NetAmount', w3,
                    'NetAmountAfterFrDiscount', w3,
                    'TaxableAmount', w3,
                    'TaxAmount', w3,
                    'DiscountCoupon', w1,
                    'EFranchiseeDiscountType', w2,
                    'EFranchiseeDiscount', w2,
                    'FranchiseeDiscountValue', w3,
                    'FranchiseeDiscountAmount', w3,
                    'EPaymentStatus', w2,
                    'EPaymentType', w2,
                    'Gstin', w1,
                    'Note', w7,
                    'EmailSendCount', w6,
                    'OrderInstallments', w9,
                    'HasBooks', w10,
                    'MailId', w1,
                    'CurrencyId', w4,
                    'IsEmailSent', w10,
                    'LastEmailSentDate', w0,
                    'FreezeData', w10
                ]);
            }
        }
    }
}
